import React from 'react'
import { connect } from 'react-redux'
import MatxSnackbar from './MatxSnackbar'

const AlertContainerComp = (props) => {
    return (
        <div className="alerts">
            {props.messages.map((message, index) => (
                <MatxSnackbar key={'alert-' + index} message={message} />
            ))}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        messages: state.alerts.messages,
    }
}

export const AlertContainer = connect(mapStateToProps)(AlertContainerComp)
